import {Component, OnInit} from '@angular/core';
import {MenuItem} from '../../model/MenuItem';
import {AuthService} from '../../service/auth.service';
import {NavigationEnd, Router} from '@angular/router';
import {UrlHelper} from '../../helper/url.helper';

@Component({
  selector: 'app-stats-dashboard',
  templateUrl: './stats-dashboard.component.html',
  styleUrls: ['./stats-dashboard.component.scss']
})
export class StatsDashboardComponent implements OnInit {

  links: MenuItem[] = [
    {
      path: 'enrol',
      label: $localize`:Navigation|Enrol Stats title@@navigation-enrol-stats-title:Enrol Stats`
    },
    {
      path: 'results',
      label: $localize`:Navigation|Contest results title@@navigation-contest-results-stats-title:Contest Results`
    },
    {
      path: 'contest',
      label: $localize`:Navigation|Contest participation stats title@@navigation-contest-participation-stats-title:Contest Stats`
    },
    {
      path: 'teachers',
      label: $localize`:Navigation|Teacher results title@@navigation-teacher-results-stats-title:Teacher Results`
    },
    {
      path: 'printable',
      label: $localize`:Navigation|Printable reports title@@navigation-printable-reports-title:Printable Reports`
    }
  ];

  noStatsSelected = false;

  constructor(private authService: AuthService,
              private router: Router) {
  }

  ngOnInit() {
    this.noStatsSelected = this.router.url == UrlHelper.STATS_DASHBOARD_PATH;
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.noStatsSelected = event.url == UrlHelper.STATS_DASHBOARD_PATH;
      }
    });
    // const session = await this.authService.getSession();
    // if (session && (session.isTeacher() || session.isStudent())) {
    //   this.links.push({
    //     path: 'school',
    //     label: $localize`:Navigation|User school title@@navigation-user-school-title:School`
    //   });
    // }
  }
}
